import React, { Component } from "react";
import Comment from "../../../../common/comments/comment.component";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Loading } from "../../../../../components/common/loading";
import { disputeCommentActions } from '../../../../../store/external/invoice/dispute/dispute-comments.reducer';
import { MAX_LENGTH } from "../../../../../../app/constants/external-constants";


class DisputeComment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
        }

    }

    componentDidMount() {
        const { getInvoiceDisputeComments } = this.props;
        getInvoiceDisputeComments(this.props.disputeDetailsId)
        .then(()=>{ this.setState({isLoading:false})
        });
    }


    postComment(attachedFilename, attachedFileData, commentDescription) {
        const { postInvoiceDisputeComments, getInvoiceDisputeComments } = this.props;
        postInvoiceDisputeComments(this.props.disputeDetailsId, attachedFilename, attachedFileData, commentDescription);
        getInvoiceDisputeComments(this.props.disputeDetailsId)
            .then(()=>{ this.setState({isLoading:false})
            });       
    }

    handleDeleteDisputeComments = async (disputeDetailsId) => {
        this.setState({isLoading:true});
        const { deleteInvoiceDisputeComments, getInvoiceDisputeComments } = this.props;
        await deleteInvoiceDisputeComments(disputeDetailsId, this.props.disputeDetailsId);
        await getInvoiceDisputeComments(this.props.disputeDetailsId) .then(()=>{
            this.setState({isLoading:false})
        });
        this.setState({show : false})
    }



    render() {
        if (this.state.isLoading) {
            return <Loading />
        }
        const { roles } = this.props
        return (
            <Comment
                commentList={this.props.invoiceDisputeComments.InvoiceDisputeComments}
                addCommentAction={this.postComment.bind(this)}
                deleteCommentAction={this.handleDeleteDisputeComments.bind(this)}
                maxLength={MAX_LENGTH.limit_500}
                isDisputeComment={true}
                {...roles}
            />
        )
    }
}

export default connect(
    state => {
        const { invoiceDisputeComments } = state;

        return {
            invoiceDisputeComments
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, disputeCommentActions),
        dispatch
    )
)(DisputeComment);
